var exports = {
  "p": "x4ddf2309--9c1e44--list",
  "x": "x4ddf2309--9c1e44--list-item",
};

module.exports = exports;
